import script from "./EditSharedBoxUserList.vue?vue&type=script&setup=true&lang=js"
export * from "./EditSharedBoxUserList.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/pc/share.css?vue&type=style&index=0&id=25ebcdb8&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25ebcdb8"]])

export default __exports__